/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useErrorMessageWithIconStyles = makeStyles((theme: Theme) => ({
  error: {
    color: theme.palette.error.main,
    marginLeft: '5px',
    paddingTop: '3px',
  },
  errorWrap: {
    display: 'flex',
    alignItems: 'center',

    '& span': {
      marginLeft: '5px',
      paddingTop: '3px',
    },
  },
  errorIcon: {
    color: theme.palette.error.main,
    width: '18px',
    height: '18px',
  },
}));
